module.exports = __webpack_public_path__ + "img/Article-image8.bf0b102a.jpg";